import { Box, Card, Grid, Typography } from '@mui/material';
import DashboardPreviousCard from 'app/components/Card/DashboardPreviousCard';


function DashboardParticipantCard({ mainData }) {

    return (

        <Grid container spacing={1} direction="row" marginTop={'1px'}>
            <Card
                sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '12px',
                    boxShadow: 3,
                    padding: '10px 8px 8px 12px',
                    marginLeft: 1,
                    height: '100%',
                    width: 'auto',
                    minHeight: '190px'
                }}
            >
                <Typography sx={{ color: '#5b5b5b', padding: '5px', fontSize: '13px', paddingBottom: '7px' }}>
                    Toplantı İzleme
                </Typography>


                <Grid item xs={12} md={12} lg={12}>
                    <Grid container spacing={1} direction="row">
                        {mainData.length > 0 ? (
                            mainData.map((meeting, index) => (
                                <Box key={index} sx={{ width: 'auto' }}>
                                    <DashboardPreviousCard meeting={meeting} />
                                </Box>
                            ))
                        ) : (
                            <Typography variant="body2" sx={{ color: '#AD1457', margin: 1 }}>
                                Dikkat! Katılımcısı olduğunuz değerlendirmeye, video konferans görüşmesine ya da oylamaya açık bir toplantı bulunamadı.
                            </Typography>
                        )}
                    </Grid>
                </Grid>


            </Card>

        </Grid>
    );
};

export default DashboardParticipantCard;